// import AOS from 'AOS'
setTimeout(function () {
  jQuery('.header-bg').addClass('zoom-out');
}, 0);
